import { type FC, type ReactElement } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';

import HeadingLevel, { type HeadingType } from 'dibs-controlled-heading/exports/HeadingLevel.tsx';
import { type SharedIconicDesignHeadingsWrapper_itemSearch$data } from './__generated__/SharedIconicDesignHeadingsWrapper_itemSearch.graphql.ts';

type Props = {
    itemSearch: SharedIconicDesignHeadingsWrapper_itemSearch$data;
    showContentModule: boolean;
    children: (arg0?: HeadingType) => ReactElement;
};

const SharedIconicDesignHeadingsWrapperComponent: FC<Props> = ({
    itemSearch,
    showContentModule,
    children,
}) => {
    const isSubHeaderAvailable = !!itemSearch?.meta?.subHeader;
    const wrapTopLevel = isSubHeaderAvailable || showContentModule;
    const additionalHeadingWrapper = isSubHeaderAvailable && showContentModule;
    return wrapTopLevel ? (
        <HeadingLevel>
            {H2 => (
                <>
                    {additionalHeadingWrapper ? (
                        <HeadingLevel>{H3 => children(H3)}</HeadingLevel>
                    ) : (
                        children(H2)
                    )}
                </>
            )}
        </HeadingLevel>
    ) : (
        children()
    );
};

export const SharedIconicDesignHeadingsWrapper = createFragmentContainer(
    SharedIconicDesignHeadingsWrapperComponent,
    {
        itemSearch: graphql`
            fragment SharedIconicDesignHeadingsWrapper_itemSearch on ItemSearchQueryConnection {
                meta {
                    subHeader
                }
            }
        `,
    }
);
